export default __webpack_public_path__ + "static/media/create-icon.4c60305d.png";